const MenuToggle = document.querySelector('.masthead-toggle');
if (MenuToggle) {
    MenuToggle.addEventListener("click", () => {
        document.body.classList.toggle("masthead-nav--show");
    });
}
export default undefined;
